import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GraphqlService } from '../../../service/graphql.service';
import { OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  Validators,
} from '@angular/forms';
import { Category } from '../../../model/category';


enum ModalType {
  ADD,
  EDIT,
  ADD_SUBCATEGORY,
}

@Component({
  selector: 'app-category-modal',
  imports: [FormsModule],
  templateUrl: './category-modal.component.html',
  styleUrl: './category-modal.component.scss',
  standalone: true,
})
export class CategoryModalComponent implements OnInit {
  @Input() category: Category | null = null;
  @Output() closeModal = new EventEmitter<void>();

  modalType: ModalType = ModalType.ADD;
  ModalType = ModalType;
  categoryForm: FormGroup;

  constructor(private graphqlService: GraphqlService) {
    this.categoryForm = new FormGroup({
      name: new FormControl('', Validators.required),
      description: new FormControl('', Validators.required),
      parentId: new FormControl(null),
    });
  }

  ngOnInit() {
    this.categoryForm.patchValue({
      name: this.category?.name,
      description: this.category?.description,
      parentId: this.category?.parentId,
    });

    if (
      this.category?.parentId &&
      !this.category.name &&
      !this.category.description
    ) {
      this.modalType = ModalType.ADD_SUBCATEGORY;
    } else if (!this.category?.name && !this.category?.description) {
      this.modalType = ModalType.ADD;
    } else {
      this.modalType = ModalType.EDIT;
    }
  }

  onSave() {
    if (this.modalType === ModalType.EDIT) {
      this.graphqlService
        .updateCategory(
          this.category!.id,
          this.categoryForm.value.name,
          this.categoryForm.value.description,
          this.categoryForm.value.parentId,
        )
        .subscribe({
          next: () => {
            this.closeModal.emit();
          },
          error: (error) => {
            console.error('Fehler beim Aktualisieren der Kategorie: ', error);
          },
        });
    } else {
      this.graphqlService
        .addCategory(
          this.categoryForm.value.name,
          this.categoryForm.value.description,
          this.categoryForm.value.parentId,
        )
        .subscribe({
          next: (response) => {
            console.log(
              this.categoryForm.value.name,
              this.categoryForm.value.description,
            );
            console.log('Kategorie wurde erfolgreich hinzugefügt:', response);
            this.closeModal.emit();
          },
          error: (error) => {
            console.error('Fehler beim Hinzufügen der Kategorie:', error);
          },
        });
    }
  }

  onCancel() {
    this.closeModal.emit();
  }
}
